const React = window.React;

export function removeForm(){
    const elForm = document.querySelector( '#convertr-form' );
    if( elForm ){
        elForm.remove();
    }
    const elH2 = document.querySelector( '.form-wrapper h2' );
    if( elH2 ){
        elH2.remove();
    }
}

export function removeFormForSubmit(){
    const elFormDigioh = document.getElementById( 'digioh-form-wrapper' );
    if( elFormDigioh ){
        elFormDigioh.remove();
    }

    const elForm = document.querySelector( '#convertr-form' );
    if( elForm ){
        elForm.remove();
    }
}

export function getLightboxNameFromSelector(v) {
        const match = DIGIOH_LIGHTBOX_CONDITIONS.find(item => {
        if (!item.conditions || !Array.isArray(item.conditions)) return false;

            return item.conditions.some(group =>
                Array.isArray(group) &&
                group.some(cond => cond.v && cond.v.includes(v))
            );
        });

        if (!match) return null;

        const guid = match.lightbox_guid;

        const name = window.DIGIOH_LIGHTBOX_NAMES[guid] || null;

        return name;
	}

export default function regKey(){
    if( adw?.webinar_meta?.registration_url ){
        return "aw_webinar_" + btoa( adw.webinar_meta.registration_url );
    }
    return null;
}

export function removeLoader( container ){

    let elLoading = null;
    if( container ){
        elLoading = container.querySelector( '[data-loading]' );
    } else {
        elLoading = document.querySelectorAll( '#convertr-form [data-loading]' );
    }
    if( elLoading ){
        elLoading.remove();
    }
}

export function registerUserOnZephr( {fieldValues, email, password} ){

    return new Promise( async (resolve, reject) => {
    
        let user = {
            identifiers: {
                email_address: email
            },
            attributes: fieldValues
        };

        if( password ){
            user['validators'] = {
                password: password
            }
        }

        try{
            const response = await fetch( `${window.location.origin}/blaize/register`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                },
                body: JSON.stringify(user),
            } )

            const data = response.json();
            return resolve( data );

        } catch ( err ){
            return reject( err );
        }
        
    } );

}

export async function startPasswordlessAuthOnZephr( {email, action = 'login'} ){
    try{
        const response = await fetch( `${window.location.origin}/blaize/token-exchange`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
            },
            body: JSON.stringify({
                "identifiers": {
                    "email_address": email
                },
                "delivery": {
                    "method": "email",
                    "destination": email,
                    "action": action,
                    "redirect": `/${window.location.href}`
                }
            }),
        } )
    } catch ( err ){
        return reject( err );
    }
}

export function createTemporarySession( {firstName} = {} ){
    if( typeof updateUserStateInNav === 'function' && firstName ){
        updateUserStateInNav( {
            name: firstName,
            isLoggedIn: true,
            isSubscribed: false,
            isRegistered: true,
            isEmailVerified: false
        } );
    }
}

// Set local storage value
export const setRegStatusLocalStorage = ( email = '', unset = false ) => {
    const localStorageKey = regKey();
    if( unset ){
        localStorage.removeItem( localStorageKey );
    } else {
        localStorage.setItem( localStorageKey, JSON.stringify( btoa( email ) ) );
    }
};

// Get local storage value
export const getRegStatusLocalStorage = ( ) => {
    const localStorageKey = regKey();
    if( !localStorageKey ) return false;
    const localStorageValue = localStorage.getItem( localStorageKey );
    if( localStorageValue ){
        return JSON.parse( atob( localStorageValue ) );
    }
    return false;
}

export const setRegStatusCookies = ( email ) => {
    if( typeof Cookies === 'function' ){
        const cookieKey = regKey();
        if( !cookieKey ) throw new Error('No cookie key available');
        Cookies.set( cookieKey, JSON.stringify( btoa( email ) ), { expires: 30 } );
    }
};
export const getRegStatusCookies = ( ) => {
    if( typeof Cookies === 'function' ){
        const cookieKey = regKey();
        if( !cookieKey ) throw new Error('No cookie key available');
        const cookieValue = Cookies.get( cookieKey );
        if( cookieValue ){
            return atob( JSON.parse( cookieValue ) );
        }
    }
    return false;
};

export const getRegStatusClientSide = ( ) => {
    return( getRegStatusCookies() || getRegStatusLocalStorage() );
}

export const setRegStatusClientSide = ( email = '' ) => {

    setRegStatusCookies( email );
    setRegStatusLocalStorage( email );
    adw.webinar_meta.is_registered = true
}

export const registerUserForWebinar = function( args, postId = null ){
    
    return new Promise( (resolve, reject) => {

        const params = new URLSearchParams();
        for( const key in args ){
            params.set( key, args[key] );
        }

        // Add post ID to params if available
        if( postId ){
            params.set( 'post_id', postId );
        }

        const queryString = params.toString();

        // If registration_url is set in post meta, use the new default registration flow
        const registrationUrl = adw?.webinar_meta?.registration_url;

        if( registrationUrl ){
            const {
                fname,
                lname,
                email,
                firstName,
                lastName,
                emailAddress,
                ...additionalFields
            } = args;

            const registrationPayload = {
                firstName: firstName || fname || '',
                lastName: lastName || lname || '',
                emailAddress: emailAddress || email || '',
                ...additionalFields,
            };

            const requestPayload = {
                ...registrationPayload,
                post_id: Number( postId || adw?.post?.id || 0 ),
                registration_url: registrationUrl,
            };

            fetch( `${window.location.origin}/wp-json/adw_webinar_registration/v1/registration/`, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify( requestPayload ),
            } )
                .then(response => {
                    return response?.json?.() || {};
                }).then( response => {
                    return resolve( response )
                })
                .catch(error => reject( error ));
            
        } else {

            // To-Do: Remove this legacy registration flow after confirming all clients have updated to the new flow that uses the registration_url post meta field
            fetch( `${window.location.origin}/wp-json/adw-webcasts/v1/register_user/?${queryString}` )
                .then(response => {
                    if( response.status !== 200 ){
                        return reject();
                    }
                    return response.json();
                })
                .then( response => resolve( response ) )
                .catch(error => reject( error ));
        }

        // Send data to BigQuery
        sendRegistrationDataToBigQuery( queryString );

    } )        
};

function isProductionDomain() {
    const host = window.location.host;
    return host === "www.adweek.com" || host === "adweek.com";
}

function buildIterableEndpoint(path) {
    const base = isProductionDomain()
        ? "https://audience.adweek.com"
        : "https://audience-develop.adweek.com";

    return base + path;
}

export const sendRegistrantToIterable = function( args ){

	const endpoint = buildIterableEndpoint('/wp-json/adw-zephr/v2/webinar-registration-to-iterable');

	if(!endpoint){
		throw new Error('No iterable endpoint');
	}

	return new Promise( (resolve, reject) => {

		fetch(endpoint, {
			method: 'POST',
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(args),
		})
			.then(response => {

				if (response.status !== 200) {
					return reject();
				}

				return response.json();
			})
			.then(response => resolve(response))
			.catch(error => reject(error));

	})
};

function sendRegistrationDataToBigQuery( queryString ){
    if( !( adw?.webinar_meta?.bigquery_webhook ) ) return;
    return fetch( `${adw.webinar_meta.bigquery_webhook}/?${queryString}` )
        .then(response => {
            if( response.status !== 200 ){
                return reject();
            }
            console.log( response );
        })
        .catch(error => console.error( 'Error in BigQuery Webhook', error ));
}

export const getEnterTheWebinarLink = ( {email} ) => {

    if( !email ) return ``;

    if( adw?.webinar_meta?.registration_url ){
        return `${adw.webinar_meta.auto_join_url}?emailAddress=${email}`;
    }

    // To-Do: Update this function to use the registration_url post meta field for generating the webinar entry link if it's set, and remove legacy support for the old entry link format that relies on the event_id query param after confirming all clients have updated to the new flow 
    return `https://event.webcasts.com/starthere.jsp?ei=${adw.webinar_meta.event_id}&email=${email}`;
}

export const useAnimIn = ( ref, options = {} ) => {
    React.useEffect( () => {

        if( typeof anime === 'function' && ref?.current !== 'undefined' ){

            anime( {
                targets: ref.current,
                opacity: [0, 1],
                translateY: [10, 0],
                duration: 500,
                easing: 'easeOutQuad',
                ...options,
                complete: function( anim ){

                }
            } )
        }
    }, [ref] );
}

export const useStateWithClientStorage = ( key, val ) => {

    const getValWithBoolCheck = ( val ) => {
        if( val === 'true' ){
            val = true;
        } else if ( val === 'false'){
            val = false;
        } 
        return val;
    }

    const setClientState = ( val ) => {
        localStorage.setItem( key, val );
    }

    const valFromLocalStorage = JSON.parse( localStorage.getItem( key ) );
    let valForState = null;
    if( valFromLocalStorage ){
        valForState = getValWithBoolCheck( valFromLocalStorage );
    } else {
        valForState = val;
    }

    const [state, setState] = React.useState( valForState );
    React.useEffect( () => {
        localStorage.setItem( key, JSON.stringify( getValWithBoolCheck( state ) ) );
    }, [state] );

    return [state, setState, setClientState ];

}

export const useMinheight = ( ref ) => {
    React.useEffect( () => {

        if( ref.current ){
            const elHeight = ref.current.getBoundingClientRect().height;

            if( typeof elHeight === 'number' && elHeight > 0 ){
                ref.current.style.minHeight = `${elHeight}px`;
            }
        }
    }, [ref] );
}